
import Section1 from "@/views/catalogue/views/section-1/navigation/section-1.nav";

const navigation = [
    {
        header: 'CATALOGUE'
    },
    Section1,
];

export default navigation;